import { useEffect } from 'react';
import type { BoothPanelProps } from '../panels';
import styles from '../BoothOverlay.module.scss?module';

/** Placeholder; the panel content follows in its own work package. */
export default function SuggestedPanel({ tab, onBadge }: BoothPanelProps) {
  useEffect(() => {
    onBadge(tab, null);
  }, [tab, onBadge]);

  return <p className={styles.panelPlaceholder}>Suggestions follow.</p>;
}
